if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.addUpsell__cart = document.querySelector('.addUpsell__cart');
        this.addUpsell__cart?.addEventListener('click', this.addUpsell.bind(this));

        this.declineUpsell__cart = document.querySelector('.declineUpsell__cart');
        this.declineUpsell__cart?.addEventListener('click', this.declineUpsell.bind(this));

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.bypassUpsell = false; // Initialize the bypassUpsell flag
      }

      // Method to handle accpect of upsell
      addUpsell(evt) {
        evt.preventDefault();
        console.log("addUpsell clicked");
      
        this.bypassUpsell = true; // Set flag to bypass upsell
        const id = evt.target.getAttribute("data-val");
      
        const self = this; // Store reference to 'this' in case of context issues
      
        $.ajax({
          type: "post",
          dataType: "json",
          async: false, // Synchronous request (not recommended, but following your current code)
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: id
          },
          success: function(data) {
            console.log("Upsell product added to cart:", data);
      
            // Close the upsell popup modal
            document.querySelector('.upsell-popup-modal .product-popup-modal__toggle').dispatchEvent(new Event('click'));
      
            // Debugging log
            console.log("Attempting to re-submit the form:", self.form);
      
            // Ensure the form exists and is not disabled
            if (self.form && !self.form.hasAttribute('disabled')) {
              try {
                // Re-submit the form
                self.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                console.log("Form submission event dispatched");
              } catch (error) {
                console.error("Error dispatching form submit event:", error);
              }
            } else {
              console.warn("Form is either null or disabled, directly calling onSubmitHandler");
              // Directly call the form submission handler if the event is not working
              self.onSubmitHandler(evt);
            }
          },
          error: function(error) {
            console.error("Error adding upsell product to cart:", error);
          }
        });
      }

      // Method to handle decline of upsell
      declineUpsell(evt) {
        evt.preventDefault();
        console.log("DeclineUpsell clicked");
        this.bypassUpsell = true; // Set flag to bypass upsell
        document.querySelector('.upsell-popup-modal .product-popup-modal__toggle').dispatchEvent(new Event('click'));
        this.form.dispatchEvent(new Event('submit')); // Re-submit form after upsell decline
      }

      // Form submission handler
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        $('.addons_list .addons_list_item').each(function(){
            var id =  $(this).find('input:checked').val();
            console.log(id, "here" )
            if( id != undefined){
              addp(id);
            }
        });
        function addp(v) {
          $.ajax({
            type:"post",
            dataType: "json",
            async:false,
            url: '/cart/add.js',
            data:{quantity:1,id:v},
            success: function(data){
            }
          });
        };

        const upsellBtn = document.querySelector('.UpsellPopupModal-button');
        const onetime = document.querySelector('.yotpo-selected.yotpo-radio-buy-once-container');

        // Check for upsell popup and bypass if decline button was clicked
        if (
          !this.bypassUpsell &&
          upsellBtn != null &&
          onetime != null &&
          !sessionStorage.getItem('upsellShown')
        ) {
          console.log("Upsell and button found, showing upsell popup");
        
          // Mark the upsell popup as shown in session storage
          sessionStorage.setItem('upsellShown', 'true');
        
          // Show the upsell popup
          document.querySelector('.UpsellPopupModal-button .product-popup-modal__button').dispatchEvent(new Event('click'));
        
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
          this.querySelector('.loading__spinner').classList.add('hidden');
          return; // Stop further execution until upsell is handled
        }
 
        // Proceed with form submission if no upsell or bypassed
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.bypassUpsell = false; // Reset the bypassUpsell flag
          });
      }

      // Handle error messages
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Toggle the submit button state
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      // Get the variant ID input field
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
